document.querySelectorAll('.scroll-on-compare-section').forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    e.preventDefault();

    const target = document.querySelector('.bumzzy-comparison-table-section-element');
    const offset = 10;

    const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  });
});